import { ID } from "."

export type Extra = {
  id: ID
  name: string
  description: string
  photos: string[]
}

export type Option = {
  id: ID
  name: string
  description: string
  photos: string[]
}

export type Supplement = {
  id: ID
}

export type ExtraStock = {
  availability: number
  startDate: Date
  endDate: Date
  establishmentId: number
  organizationId: number
  serviceId: number
  serviceTypeId: number
}

export type OptionStock = {
  availability: number
  startDate: Date
  endDate: Date
  establishmentId: number
  organizationId: number
  serviceId: number
  serviceTypeId: number
}

export enum OptionPriceMode {
  JourPers = "jourpers",
  ParPers = "parpers",
  ParJour = "parjour",
  Unique = "unique",
  Semaine = "semaine",
  SemainePers = "sempers",
  PourcJour = "pourc_jour",
  PourcJourHt = "pourc_jour_ht",
  PourcJourPers = "pourc_jourpers",
}